<template>
  <transition name="slide">
    <CCard>
      <CCardBody>
        <CButton color="primary" @click="create()"
          ><CIcon name="cil-plus" /> Create New Add On</CButton
        >
        <br />
        <br />
        <br />

        <CAlert :color="alertType" v-if="message"> {{ message }}</CAlert>
        <CDataTable
          :items="items"
          :fields="fields"
          :items-per-page="50"
          hover
          pagination
        >
          <template #name="{ item }">
            <td>
              <strong>{{ item.nameTranslations[0].name }}</strong>
            </td>
          </template>

          <template #minQuantity="{ item }">
            <td>
              <strong>{{ item.minQuantity }}</strong>
            </td>
          </template>
          <template #maxQuantity="{ item }">
            <td>
              <strong>{{ item.maxQuantity }}</strong>
            </td>
          </template>
          <template #price="{ item }">
            <td>
              <strong>{{ item.price }}</strong>
            </td>
          </template>
          <template #currencyCode="{ item }">
            <td>
              <strong>{{ item.currencyCode }}</strong>
            </td>
          </template>

          <template #EDIT="{ item }">
            <td style="width: 15%">
              <CButton color="primary" @click="edit(item.id)"
                ><CIcon name="cil-pencil" /> Edit</CButton
              >
            </td>
          </template>
          <template #DELETE="{ item }">
            <td style="width: 15%">
              <CButton
                color="danger"
                @click="
                  warningModal = true;
                  addOn = item;
                "
                ><CIcon name="cil-trash" /> Delete</CButton
              >
            </td>
          </template>
        </CDataTable>

        <CModal
          v-model="addOn.id"
          title="Are you sure to delete selected add on?"
          color="danger"
          :show.sync="warningModal"
          @update:show="closeModal"
        >
          <CRow>
            <CCol col="12">
              <CInput
                label="Name"
                type="input"
                v-model="addOn.nameTranslations[0].name"
                disabled
              />
            </CCol>
          </CRow>
        </CModal>
      </CCardBody>
    </CCard>
  </transition>
</template>

<script>
import axios from "axios";

export default {
  name: "AddOns",
  data: () => {
    return {
      token: localStorage.getItem("api_token"),
      partnerId: localStorage.getItem("partner_id"),
      emptyGuid: "00000000-0000-0000-0000-000000000000",
      addOn: {
        id: null,
        minQuantity: null,
        maxQuantity: null,
        price: null,
        currencyCode: null,
        nameTranslations: [
          {
            name: null,
          },
        ],
      },
      warningModal: false,
      items: [],
      fields: [
        "name",
        "minQuantity",
        "maxQuantity",
        "price",
        "currencyCode",
        "EDIT",
        "DELETE",
      ],

      // Alert
      message: null,
      alertType: "danger",
    };
  },
  computed: {},
  methods: {
    closeModal(status, evt, accept) {
      if (accept) {
        this.delete(this.addOn.id);
      }
    },
    edit(id) {
      const link = `addons/create/${id.toString()}`;
      this.$router.push({ path: link });
    },
    delete(id) {
      let self = this;
      axios
        .delete(`${this.$apiAdress}/v1/AddOn/${id}`)

        .then(function () {
                    self.alertType = "success";
          setTimeout(function () {
              self.message = null;
          }, 5000);
          self.message = "Successfully deleted add on.";
          self.getList();
        })
        .catch(function (error) {
                    self.alertType = "danger";
          setTimeout(function () {
              self.message = null;
          }, 10000);
          self.message = error;
        });
    },
    create() {
      this.$router.push({ path: `addons/create/${this.emptyGuid}` });
    },

    getList() {
      let self = this;
      axios
        .get(this.$apiAdress + `/v1/AddOn`)
        .then(function (response) {
          self.items = response.data;
        })
        .catch(function (error) {
                    self.alertType = "danger";
          setTimeout(function () {
              self.message = null;
          }, 10000);
          self.message = error;
        });
    },
  },
  mounted: function () {
    this.getList();
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
